import { Typography, Chip, styled } from '@material-ui/core';

export const FilterContainer = styled('div')({
  backgroundColor: '#fff',
  padding: 16,
  borderRadius: 20,
  width: 320,
});

export const FilterTitle = styled(Typography)({
  fontFamily: 'Red Hat Display',
});

export const ChipsContainer = styled('div')({
  marginBottom: 2,
  display: 'flex',
  flexWrap: 'wrap',
  gridRowGap: 1,
});

export const StyledChip = styled(Chip)({
  color: '#fff',
  '& .MuiChip-deleteIcon': {
    color: '#fff',
  },
});

export const SectionTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
});

export const EmptyMessage = styled(Typography)({
  padding: 2,
  textAlign: 'center',
});
